/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Pill_PaceInputs */

const en_ui_color_by_pill_pace = /** @type {(inputs: Ui_Color_By_Pill_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pace zones`)
};

const de_ui_color_by_pill_pace = /** @type {(inputs: Ui_Color_By_Pill_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pace-Zonen`)
};

/**
* | output |
* | --- |
* | "Pace zones" |
*
* @param {Ui_Color_By_Pill_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_pill_pace = /** @type {((inputs?: Ui_Color_By_Pill_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Pill_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_pill_pace(inputs)
	return de_ui_color_by_pill_pace(inputs)
});